import { Box, Stack, Typography } from "@mui/material";
import TitleAndContent from "./TitleAndContent";


const listMembers = [
    {
        "name": "Fin",
        "role": "IOS Developer",
        "avatarPath": "/fin.png",
        "linkedinUrl": "https://www.linkedin.com/in/finn-dev/"
    },
    {
        "name": "Harley",
        "role": "IOS Developer",
        "avatarPath": "/harley.png",
        "linkedinUrl": "https://www.linkedin.com/in/harley-pham-pham-minh-hieu-105247124/"
    },
    {
        "name": "Jonas",
        "role": "Android Developer",
        "avatarPath": "/jonas.png",
        "linkedinUrl": "https://www.linkedin.com/in/trien-hong-2a4b571b3/"
    }
]

export default function TeamSection() {
    return (
        <Stack sx={{
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            height: '100vh'
        }}>
            <TitleAndContent title={"Meet our team!"} />
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                sx={{
                    width: '100%',
                    justifyContent: "space-evenly",
                    alignItems: 'center',
                    marginTop: '10rem',
                }}>
                {mapMembers(listMembers)}
            </Stack>
        </Stack>
    )
}

const mapMembers = (members) => members.map(
    member => <Stack
        key={member.name}
        onClick={() => {
            window.open(member.linkedinUrl, `${member.name}'s profile`)
        }}
        sx={{
            alignItems: 'center',
            justifymember: 'center',
            cursor: 'pointer'
        }}>
        <Box
            component="img"
            sx={{ height: { xs: "13rem", sm: "30rem" }, width: { xs: "13rem", sm: "30rem" }, marginBottom: '6rem' }}
            alt={member.name}
            src={member.avatarPath}
        />
        <Stack direction="row" sx={{ alignItems: "flex-start" }}>
            <Typography align="center" sx={{
                fontWeight: "bold",
                fontSize: "5rem",
                lineHeight: "7.5rem",
                marginBottom: "1rem",
                whiteSpace: "pre-wrap",
                marginRight: '1rem'
            }}>
                {member.name}
            </Typography>
            <img src="/linkedin.png" sx={{
                width: "3rem", 
                height: "3rem"
            }} alt="linkedin" />
        </Stack>

        <Typography align="center" sx={{
            fontSize: "4rem",
            lineHeight: "6rem",
            whiteSpace: "pre-wrap",
            marginBottom: "10rem",
            color: '#A19FA8'
        }}>
            {member.role}
        </Typography>
    </Stack>
)